import { useEffect, useState } from 'react';

import { customGoogleFonts } from '@getbento/payments/constants/fonts';
import {
  prepareBrandStylesForConsumer,
  useClientGoogleFonts
} from '@getbento/website-components';
import { useAccount } from 'reservations/account/providers/AccountProvider';
import { Logo } from 'reservations/account/queries/useAccountQuery';
import {
  BrandFont,
  BrandStyles,
  PrivateBrandStyles
} from 'reservations/brand/types/brand';
import { usePreviewModeContext } from 'reservations/preview/providers/PreviewModeProvider';

const useBrandData = (): {
  fonts: BrandFont[];
  styles: BrandStyles;
  brandLogo: Logo;
  hasBrandLogo: boolean;
} => {
  const { previewData, isPreview } = usePreviewModeContext();

  const [styles, setStyles] = useState<BrandStyles>({ base: {}, styles: [] });

  const { brand, brandLogo } = useAccount();

  const brandStyles: PrivateBrandStyles =
    isPreview && previewData?.brandStyles != null
      ? previewData?.brandStyles
      : brand.styles;

  const brandFonts: BrandFont[] =
    isPreview && previewData?.brandFonts != null
      ? previewData?.brandFonts
      : brand.fonts;

  const hasBrandLogo: boolean = !!brand.logos.length;

  useClientGoogleFonts({
    isFeatureEnabled: true,
    brandFonts: [...customGoogleFonts, ...brandFonts]
  });

  useEffect(() => {
    setStyles(prepareBrandStylesForConsumer(brandStyles));
  }, [brandStyles]);

  return {
    fonts: brandFonts,
    styles,
    brandLogo,
    hasBrandLogo
  };
};

export default useBrandData;
